module.exports = __webpack_public_path__ + "static/media/Show_derails1.079ff18a.svg";